export const FILTER_SET_SCOPES = [
  'company',
  'company_screener',
  'economic_impact',
  'geography',
  'geography_screener',
  'industry',
  'posting_discovery',
  'role',
  'role_screener',
  'skill',
  'activity',
  'talent_discovery',
] as const;

export type FilterSetScope = (typeof FILTER_SET_SCOPES)[number];

export const isFilterSetScope = (value: unknown): value is FilterSetScope =>
  typeof value === 'string' &&
  (FILTER_SET_SCOPES as readonly string[]).includes(value);

export const FILTER_SET_NAME_MAX_LENGTH = 200;

export const FILTER_SET_URL_MAX_LENGTH = 262_144;

export const FILTER_SET_PER_OWNER_LIMIT = 200;

export interface FilterSet {
  id: string;
  ownerId: string;
  name: string;
  scope: FilterSetScope;
  url: string;
  createdAt: string | null;
  updatedAt: string | null;
}

export const toFilterSetNameKey = (name: string): string =>
  name.trim().toLowerCase();
